module.exports = __webpack_public_path__ + "static/media/extra.10a92257.gif";